import { apiClient } from './axios'

export const login = async (token) => {
  try {
    return await apiClient.post(`api/login`, { token })
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const activateUserService = async (id) => {
  try {
    return await apiClient.get(`api/activate-user/${id}`)
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const register = async (email, password) => {
  try {
    return await apiClient.post(`api/register`, { email, password })
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const loginPw = async (email, password) => {
  try {
    return await apiClient.post(`api/login-pw`, { email, password })
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const setPassword = async (password) => {
  try {
    return await apiClient.post(`api/set-password`, { password })
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const logout = async () => {
  try {
    return await apiClient.get('api/logout')
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const checkLogin = async () => {
  try {
    return (await apiClient.get('api/check-login')).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}

export const checkTeam = async (compId) => {
  try {
    return (await apiClient.get(`api/is-valid-team/${compId}`)).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}


export const sendPWReset = async (email) => {
  try {
    return (await apiClient.post('api/forgot-password', {email})).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}


export const newPw = async (token, newPassword) => {
  try {
    return (await apiClient.post('api/reset-password', {token, newPassword})).data
  }catch (err){
    console.error('Hiba történt, kérem próbálkozzon újra')
    return false
  }
}